<template>
  <div class="panel node_construction" ref="node_construction">
    <div class="panel_title">{{ title }}</div>
    <div class="panel_body">
      <ul>
        <template v-for="(item, i) in dataList1">
          <li
            :key="i"
            :_key="i"
            class="wow animate__animated animate__fadeInDown"
            :style="{ 'animation-delay': i * 0.1 + 's' }"
          >
            <div>
              <div class="value">
                <countTo :ref="'countTo' + i" :startVal="0" :endVal="item.value" :duration="3000" separator="" />
                <span class="unit" v-if="item.unit">{{ item.unit }}</span>
              </div>
              <div class="label">{{ item.label }}</div>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import countTo from "vue-count-to";
import { headerHeight } from "@/assets/style/style.module.less";
import { mapState } from "vuex";
export default {
  name: "node_construction",
  components: { countTo },
  data() {
    return {
      title: "晋中开发区工业互联网标识解析二级节点建设进展",
      runded: false,
    };
  },
  computed: {
    ...mapState("homeData", ["dataList1"]),
  },
  methods: {
    scrollEvent() {
      var runList = [];
      // 动画执行范围偏差值
      const transformY = 0;
      this.dataList1.forEach((item, index) => {
        var obj = this.$refs["countTo" + index][0];
        if (obj) {
          runList.push(obj);
        }
      });
      if (runList.length) {
        let tar = runList[0],
          rect = tar.$el.getBoundingClientRect();
        if (rect.top + transformY > parseInt(headerHeight) && rect.bottom + transformY < window.innerHeight) {
          if (this.runded === false) {
            try {
              runList.forEach(item => {
                item.reset();
                item.start();
              });
            } catch (error) {
              console.error(error);
            }
            this.runded = true;
          }
        } else {
          this.runded = false;
        }
      }
    },
    initData() {
      this.$store.dispatch("homeData/getDataList");
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    window["node_construction"] = this;
    window._addScrollFun("node_construction", this.scrollEvent);
  },
  beforeDestroy() {
    window._removeScrollFun("node_construction");
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
